<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <h4>{{ data.sub_company ? data.sub_company.toUpperCase() : "--" }}</h4>
    </v-layout>
    <v-layout align-center justify-center>
      <h3>ABSTRACT OF DAILY CASH REPORT</h3>
    </v-layout>
    <v-layout align-center justify-center>
      <h4>{{ remittanceDate ? $dateFormat(remittanceDate, "YYYY-MM-DD HH:mm A"): "--" }}</h4>
    </v-layout>

    <v-layout justify-center class="clsScroll">
      <v-data-table :headers="headers" :items="remittances" hide-actions disable-initial-sort>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.or_no ? props.item.or_no: "--" }}</td>
          <td class="text-xs-center">{{ props.item.vehicle_no }}</td>
          <td
            class="text-xs-right text-no-wrap"
          >{{ props.item.trip_date ? $dateFormat(props.item.trip_date, "YYYY-MM-DD HH:mm A") : "--" }}</td>
          <td class="text-no-wrap text-xs-right">{{ props.item.no_of_trips }}</td>
          <td class="text-no-wrap text-xs-right">{{ props.item.km_run }}</td>
          <td
            class="text-no-wrap text-xs-left"
          >{{ props.item.driver ? props.item.driver.toUpperCase() : "--" }}</td>
          <td
            class="text-no-wrap text-xs-left"
          >{{ props.item.conductor ? props.item.conductor.toUpperCase() : "--" }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.gross_income) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.partial_special) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.dricon_commission) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.toll_road) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.dricon_advances) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.net_cash) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.short_over) }}</td>
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.merchant_id }}</td> -->

          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.control_no }}</td> -->
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.ticket_no }}</td> -->
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.card_no }}</td> -->
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.device_serial }}</td> -->
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.or_no }}</td> -->
          <!-- <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.amount) }}</td> -->
          <!-- <td class="text-no-wrap text-xs-right">{{ $amountInPeso(props.item.mdr) }}</td> -->
        </template>
        <template slot="footer">
          <td class="text-xs-left">
            <strong>Total</strong>
          </td>
          <td class="text-xs-center">{{total.count}}</td>
          <td class="text-xs-right"></td>
          <td class="text-xs-right">{{total.no_of_trips}}</td>
          <td class="text-xs-right">{{total.km_run}}</td>
          <td class="text-xs-right"></td>
          <td class="text-xs-right"></td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.gross_income) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.partial_special) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.dricon_commission) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.toll_road) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.dricon_advances) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.net_cash) }}</td>
          <td class="text-no-wrap text-xs-right">{{ $amountInPeso(total.short_over) }}</td>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    remittances: Array,
    total: Object,
    headers: Array,
    remittanceDate: String
  },
  data() {
    return {
      reference_no: null
    };
  },
  created() {},
  computed: {
    computedData() {
      return this.remittances;
    }
  },
  methods: {}
};
</script>

<style scoped>
.data-tab {
  border: 2px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-tabletab {
  width: 100%;
}
.td1 {
  border: 2px solid;
  padding-right: 10px;
  padding-left: 10px;
}
.clsScroll {
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
}
input[type="text"] {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
select {
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.uploading-image {
  display: flex;
}
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
